module.exports = __webpack_public_path__ + "img/join-1.2bcb1ba3.png";